import { useAuthStore } from "@/stores/auth.module";
import { computed } from "vue";

export function createDeletablePermission(store: {
  item: { editRepeat?: string | null };
}) {
  const authStore = useAuthStore();

  return computed(() => {
    return store.item.editRepeat === "single" || authStore.isSuperUser;
  });
}
